'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishMessageToConversation = publishMessageToConversation;

var _getLiveChatAttachments = require('conversations-schema/pubnub-message/operators/getLiveChatAttachments');

var _addMessageToConversation = require('../ConversationsActions/addMessageToConversation');

var _stubbedChannel = require('../../threads/constants/stubbedChannel');

var _addMessageToStubbedThread = require('../../stubbed-thread-history/actions/addMessageToStubbedThread');

var _addAvailabilityMessage = require('../../availability/actions/addAvailabilityMessage');

var _publishMessage = require('../../pubsub/actions/publishMessage');

var _associateFileAttachmentsWithChannel = require('../../file-uploads/actions/associateFileAttachmentsWithChannel');

function publishMessageToConversation(_ref) {
  var channel = _ref.channel,
      message = _ref.message;

  return function (dispatch) {
    if (channel === _stubbedChannel.STUBBED_CHANNEL) {
      dispatch((0, _addMessageToStubbedThread.addMessageToStubbedThread)(message));
    } else {
      dispatch((0, _addMessageToConversation.addMessageToConversation)({ channel: channel, message: message }));

      dispatch((0, _associateFileAttachmentsWithChannel.associateFileAttachmentsWithChannel)({
        attachments: (0, _getLiveChatAttachments.getLiveChatAttachments)(message),
        channel: channel
      })).then(function () {
        return dispatch((0, _publishMessage.publishMessage)({ channel: channel, message: message }));
      }).then(function () {
        return dispatch((0, _addAvailabilityMessage.addAvailabilityMessage)({ channel: channel }));
      }).done();
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./js/actions/PublishActions/publishMessageToConversation.js
// module id = 51
// module chunks = 2 3